// extracted by mini-css-extract-plugin
export default {"container":"StaticText_container__Q3thd","title":"StaticText_title__g2laj"};